let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // One subscriber throwing synchronously used to abort Array.map entirely,
    // silently skipping every OTHER subscriber registered after it (e.g. the
    // cart drawer's re-render never ran because an earlier subscriber threw).
    // Catching per-subscriber keeps them independent.
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data));
      } catch (error) {
        console.error(error);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
